import React, { useEffect, useState } from 'react'
import { LocationData } from '../Geolocation/LocationProvider';
import axios from 'axios'
import { Label } from '../styling/StyledComponents';
import { QuestionData } from '../Geolocation/QuestionProvider';

function Questions() {
    const [location] = LocationData()
    const [questionInfo, setQuestionInfo] = QuestionData()
    const [loading, setLoading] = useState(true)

    const fetchQuestion = async () => {
        setLoading(true);
        try {
            // First attempt to get the active question
            const activeRes = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/question/active`);
            if (activeRes.data.success) {
                console.log("Found active question:", activeRes.data.result);
                setQuestionInfo(activeRes.data.result);
                setLoading(false);
                return;
            }
        } catch (e) {
            console.error("Error fetching active question:", e);
        }
    
        // If no active question found, fall back to location-based question
        try {
            const locationRes = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/retrieve/question`, {
                lat: location.lat,
                lng: location.lng
            });
            
            if (locationRes.data.success) {
                console.log("Found location-based question:", locationRes.data.result);
                setQuestionInfo(locationRes.data.result);
            } else {
                // Reset to default if no question found
                setQuestionInfo({
                    id: 0, 
                    question: 'No question found!', 
                    max_rating: 5, 
                    min_rating: 1, 
                    max_text: "Max", 
                    min_text: "Min"
                });
            }
        } catch (e) {
            console.error("Error fetching location-based question:", e);
        }
        
        setLoading(false);
    };
    
    useEffect(() => {
        fetchQuestion();
    }, [location.lat, location.lng]);

    return (
        <div className='center m-margin'>
            {loading ? (
                <Label>Loading question...</Label>
            ) : (
                <Label id={questionInfo.id}>{questionInfo.question}</Label>
            )}
        </div>
    );
}

export default Questions;